import React from 'react'
import PropTypes from 'prop-types'
import Header from './TrainPositionsHeader'
import { Link, Route, Redirect } from "react-router-dom";

import TrainPositionMainLineName from './TrainPositionMainLineName'
import TrainPositionList from './TrainPositionList'

import TrainPositionWakayamakoLineName from './TrainPositionWakayamakoLineName'
import TrainPositionTakashinohamaLineName from './TrainPositionTakashinohamaLineName'
import TrainPositionKukoLineName from './TrainPositionKukoLineName'
import TrainPositionTanagawaLineName from './TrainPositionTanagawaLineName'
import TrainPositionKadaLineName from './TrainPositionKadaLineName'

import TrainPositionShiomibashiLineName from './TrainPositionShiomibashiLineName'
import TrainPositionSenbokuLineName from './TrainPositionSenbokuLineName'
import TrainPositionBranchList from './TrainPositionBranchList'
import Footer from './TrainPositionsFooter'
import ScrollToTop from '../shared/ScrollToTop'
import Modal from 'react-modal';
import commonImages from '../../assets/images/common/*.svg'
import MasterData from '../../data/MasterData'

class TrainPositionsApp extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    notifications: PropTypes.array.isRequired,
    nankai_update_date: PropTypes.string,
    nankai_update_time: PropTypes.string,
    koya_update_date: PropTypes.string,
    koya_update_time: PropTypes.string,
    themeName: PropTypes.string.isRequired,
    trainPositionAutoRefresh: PropTypes.bool.isRequired,
    fetchLines: PropTypes.func.isRequired,
    fetchTrains: PropTypes.func.isRequired,
    fetchNotifications: PropTypes.func.isRequired,
    fetchTrainIconSettings: PropTypes.func.isRequired,
    changeTrainPositionAutoRefresh: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    popinfoId: PropTypes.string,
  }

  async componentDidMount() {
    const { fetchMaintenance, fetchLines, fetchNotifications, fetchUserSettings, fetchDisplayStationId, fetchTrainIconSettings, popinfoId } = this.props
    await fetchDisplayStationId(popinfoId)
    await fetchMaintenance()
    await fetchLines()
    await fetchTrainIconSettings()

    window.reloadTrains = this.reloadTrains.bind(this)
    await this.reloadTrains()
    Modal.setAppElement('body');

    setInterval(() => {
      if (this.props.trainPositionAutoRefresh) {
        this.reloadTrains()
      }
    }, 45000)
  }

  componentWillUnmount() {
    window.reloadTrains = undefined
  }

  async reloadTrains() {
    const { fetchTrains, fetchNotifications } = this.props

    await fetchNotifications()
    await fetchTrains()

  }

  // 乗り換え先リスト表示
  lineSwitchItem = (station) => {
    return station.transfer.map(transferText => {
      // 空白と括弧で分割
      const line = transferText.split(/\s|（/);
      const transferName = line[0];
      const otherAppLink = MasterData.getOtherAppLink(station.id, transferText)

      return <li key={transferName} className={`d-TrainPosition-lineSwitchItem${otherAppLink ? ' is-other_app_link' : ''}`}>{transferName}</li>
    })
  }

  // ダイアログ内乗り換えリスト表示
  transferList = (station) => {
    return station.transfer.map(transferText => {
      // 空白と中点で分割
      const line = transferText.split(/\s|・/)

      if (line[0] == '地下鉄') {
        // 地下鉄の場合分割して表示
        return line.slice(1).map((singleLine) => {
          const subway = `地下鉄 (${singleLine})`
          return this.renderTransferItem(subway)
        })
      } else if (line[0] == 'JR線') {
        const otherAppLink = MasterData.getOtherAppLink(station.id, transferText)
        // 複数のLinkが設定してある場合は分割して表示する
        if (otherAppLink && Array.isArray(otherAppLink.link)) {
          return otherAppLink.link.map((link, index) => {
            const oal = { ...otherAppLink }
            oal.link = link
            return this.renderTransferItem('JR' + transferText.split(' ')[index + 1], oal)
          })
        }

        return this.renderTransferItem('JR' + transferText.split(' ')[1], otherAppLink)
      } else {
        const otherAppLink = MasterData.getOtherAppLink(station.id, transferText)
        return this.renderTransferItem(transferText, otherAppLink)
      }
    })
  }

  // ダイアログ内乗り換え路線表示
  renderTransferItem(transferName, otherAppLink = null) {
    let transfer = null
    let button = null
    if (otherAppLink) {
      transfer = (
        <a href={otherAppLink.link}>
          <p className="c-Modal-transferText is-other_app_link">{transferName}</p>
        </a>
      )
      button = (
        <a href={otherAppLink.link} className="c-Modal-transferButtonLink">
          <img src={commonImages[otherAppLink.image_name]} className="c-Modal-transferButton"/>
        </a>
      )
    } else {
      transfer = <p className="c-Modal-transferText">{transferName}</p>
    }

    return (
      <li key={transferName} className="c-Modal-transferItem">
        <img src={commonImages['transfer_dialogue']} className="c-Modal-transferIcon"/>
        {transfer}
        {button}
      </li>
    )
  }

  render() {
    const { lineName } = this.props.match.params
    const { maintenance, lines, trains, notifications, showingOperation, nankai_update_date, nankai_update_time, koya_update_date, koya_update_time, themeName, popinfoId } = this.props
    if (maintenance) return <Redirect to={`/maintenance`} />

    if (0 === lines.length) return null
    var delay_info = notifications.some(notification => notification.delay === true)
    var nankai_info = notifications.some(notification => notification.line === "南海線" && notification.delay === true)
    var koya_info = notifications.some(notification => notification.line === "高野線" && notification.delay === true)

    var search = this.props.location.search
    var params = new URLSearchParams(search);
    var paramObject = {};
    for (var [key, value] of params.entries()) {
      paramObject[key] = value;
    }

    if (paramObject.showTrainOperationInfo !== 'false') {
      if (delay_info && nankai_info && koya_info && !showingOperation) {
        return <Redirect to={{ pathname: `/lines/${lineName}/train_operation_info`, state: { referrerHash: this.props.location.hash } }} />
      }
      if (delay_info && nankai_info && !koya_info && lineName == "nankai" && !showingOperation) {
        this.props.nextNotification()
        return <Redirect to={{ pathname: `/lines/${lineName}/train_operation_info`, state: { referrerHash: this.props.location.hash } }} />
      }
      if (delay_info && nankai_info && !koya_info && lineName == "koya" && !showingOperation) {
        this.props.nextNotification()
        this.props.lineReverse()
        return <Redirect to={{ pathname: `/lines/nankai/train_operation_info`, state: { referrerHash: this.props.location.hash } }} />
      }
      if (delay_info && !nankai_info && koya_info && lineName == "koya" && !showingOperation) {
        this.props.nextNotification()
        return <Redirect to={{ pathname: `/lines/${lineName}/train_operation_info`, state: { referrerHash: this.props.location.hash } }} />
      }
      if (delay_info && !nankai_info && koya_info && lineName == "nankai" && !showingOperation) {
        this.props.nextNotification()
        this.props.lineReverse()
        return <Redirect to={{ pathname: `/lines/koya/train_operation_info`, state: { referrerHash: this.props.location.hash } }} />
      }
    }

    var update_date = lineName == "nankai" ? nankai_update_date : koya_update_date
    var update_time = lineName == "nankai" ? nankai_update_time : koya_update_time

    return (
        <ScrollToTop>
          <Header lineName={lineName} notifications={notifications} update_date={update_date} update_time={update_time} type="trains" themeName={themeName} />
          <TrainPositionMainLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionWakayamakoLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionList {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} lineSwitchItem={this.lineSwitchItem} transferList={this.transferList} />
          <TrainPositionTakashinohamaLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionKukoLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionTanagawaLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionKadaLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionShiomibashiLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionSenbokuLineName {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} />
          <TrainPositionBranchList {...this.props} lines={lines} lineName={lineName} trains={trains} themeName={themeName} lineSwitchItem={this.lineSwitchItem} transferList={this.transferList} />
          <Footer lineName={lineName} notifications={notifications} type="trains" themeName={themeName} />
        </ScrollToTop>
    )
  }
}

export default TrainPositionsApp
